import AdminDefaultClassSettings from './components/AdminDefaultClassSettings';

export default AdminDefaultClassSettings;
